import SquareSharpIcon from '@mui/icons-material/SquareSharp';
import {Grid, List, ListItem, ListItemIcon, Typography} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import React, {FC, memo} from 'react';
import {useSelector} from 'react-redux';
import {localized, localizedInterpolation} from '../../../../../i18n/i18n';
import {AppState} from '../../../../../state/store';
import {getValueLengthWithUnitByCulture} from '../../../../../utilities/helpers/culture-settings-helper';
const useStyles = makeStyles(() =>
  createStyles({
    list: {
      display: 'list-item',
      margin: '0 0 0 -17px',
    },
    listText: {
      margin: '0 0 0 -35px',
    },
  }),
);
export interface PropsFromParent {
  minHeight: string;
}

export const IntroductionRow: FC<PropsFromParent> = memo(({...props}) => {
  const classes = useStyles();
  const {unitsId} = useSelector((store: AppState) => store.urlSettingsReducer.cultureUrlParameters);
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="body1">{localized('FormCasketIntro')}</Typography>
        <List className={classes.list}>
          <ListItem>
            <ListItemIcon>
              <SquareSharpIcon sx={{fontSize: 10}} color="primary" />
            </ListItemIcon>
            <Typography className={classes.listText} variant="body1">
              {localized('FormCasketBulletPointOne')}
            </Typography>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SquareSharpIcon sx={{fontSize: 10}} color="primary" />
            </ListItemIcon>
            <Typography className={classes.listText} variant="body1">
              {localized('FormCasketBulletPointTwo')}
            </Typography>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SquareSharpIcon sx={{fontSize: 10}} color="primary" />
            </ListItemIcon>
            <Typography className={classes.listText} variant="body1">
              {localizedInterpolation('FormCasketBulletPointThree', {
                value1: getValueLengthWithUnitByCulture(unitsId, props.minHeight),
              })}
            </Typography>
          </ListItem>
        </List>
      </Grid>
    </>
  );
});
